const VERIFICATION_RESEND_COOLDOWN_SECONDS: number = 60;

const VERIFICATION_RESEND_COOLDOWN_SESSION_KEY_PREFIX: string = 'verification_resend_cooldown_until';

enum VerificationResendCooldownScope {
    SIGNUP_VERIFY = 'signup_verify',
    VERIFY_EMAIL = 'verify_email',
}

interface UseWorkyVerificationResendCooldownOptions {
    readonly cooldownScope: VerificationResendCooldownScope;
    readonly emailAddress: string;
    readonly startCooldownOnMount?: boolean;
}

interface UseWorkyVerificationResendCooldownResult {
    readonly resendCooldownSecondsRemaining: number;
    readonly isResendCooldownActive: boolean;
    readonly beginResendCooldown: () => void;
    readonly formatResendButtonLabel: (idleLabel: string) => string;
}

export type {
    UseWorkyVerificationResendCooldownOptions,
    UseWorkyVerificationResendCooldownResult,
};
export {
    VERIFICATION_RESEND_COOLDOWN_SECONDS,
    VERIFICATION_RESEND_COOLDOWN_SESSION_KEY_PREFIX,
    VerificationResendCooldownScope,
};
